import { render, staticRenderFns } from "./add-img-dialog.vue?vue&type=template&id=0455af9f&scoped=true&"
import script from "./add-img-dialog.vue?vue&type=script&lang=js&"
export * from "./add-img-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-img-dialog.vue?vue&type=style&index=0&id=0455af9f&scoped=true&lang=css&"
import style1 from "./add-img-dialog.vue?vue&type=style&index=1&id=0455af9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455af9f",
  null
  
)

export default component.exports